import { Box, Typography } from '@mui/material'
import { sharedStarIcon } from '../../assets/index'
import StarBullet from '../common/StarBullet'

export default function ProgramWhySection({
  title,
  items,
  starSrc = sharedStarIcon,
  titleMaxWidth = { md: 400, lg: 520 },
  itemFontSize = { xs: 20, sm: 24, md: 30, lg: 30 },
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: { xs: 3, md: 4, lg: 6 },
        width: '100%',
      }}
    >
      <Typography
        component="h2"
        sx={{
          fontSize: { xs: 22, md: 22 },
          lineHeight: 'normal',
          fontWeight: 400,
          color: '#111',
          flexShrink: 0,
          maxWidth: titleMaxWidth,
          whiteSpace: 'pre-line',
        }}
      >
        {title}
      </Typography>

      <Box
        component="ul"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '14px',
          width: { xs: '100%', lg: 1000 },
          maxWidth: '100%',
          listStyle: 'none',
          m: 0,
          p: 0,
        }}
      >
        {items.map((item) => (
          <Box
            component="li"
            key={item}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '20px',
              minHeight: { xs: 'auto', md: 39 },
            }}
          >
            <StarBullet src={starSrc} />
            <Typography
              component="span"
              sx={{
                fontSize: itemFontSize,
                lineHeight: 'normal',
                fontWeight: 400,
                color: '#111',
              }}
            >
              {item}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
